import { NavLink } from 'react-router-dom'
import { NAV_ITEMS } from '../../config/nav'
import Brand from './Brand'

// Desktop only. On a phone the bottom bar carries navigation and each screen
// already states its own name, so a header there would only repeat it.
//
// Height is fixed at 64px because Home's search bar sticks directly beneath it.
export default function Header() {
  return (
    <header className="hidden md:flex sticky top-0 z-30 h-16 flex-none items-center justify-between gap-6 px-6 bg-shell border-b border-hairline">
      <NavLink to="/home" aria-label="Machi Express — home">
        <Brand />
      </NavLink>

      <nav aria-label="Primary">
        <ul className="flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <li key={item.key}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `block min-h-[38px] px-3.5 py-2 rounded-btn text-body-s transition-colors duration-quick ease-out ${
                    isActive
                      ? 'text-brand font-bold bg-blush'
                      : 'text-ink-3 font-medium hover:text-brand'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  )
}
